import type { DemandeDTO } from '@/features/api/extranet/dto/Demande/shared'
import { ErreurTabSummarizer, type ErreurSummaryConfiguration } from '@/features/application/erreur-summary'
import { computed, type Ref } from 'vue'
import type { MetaDemande } from './buildDemandeStore'
import type { TabState } from '@designSystem/index'

export function useDemandeTabsSummarizer<TDemande extends DemandeDTO>(
  config: ErreurSummaryConfiguration<TDemande>,
  meta: Ref<MetaDemande<TDemande>>,
) {
  const summarizer = new ErreurTabSummarizer(config)

  const erreurTabs = computed(() => {
    return summarizer.execute(meta.value)
  })

  const tabs = computed(() =>
    Object.keys(config).map((tabKey) => {
      const estErreur = erreurTabs.value[tabKey].$estErreur
      const estErreurDirty = erreurTabs.value[tabKey].$estErreurDirty
      const tabState: TabState | undefined = !estErreur ? 'success' : estErreurDirty ? 'danger' : undefined
      return {
        tabKey,
        tabState,
      }
    }),
  )

  return { tabs }
}
